import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

interface WarehouseItem {
  id: string;
  name: string;
  address: string | null;
  is_default: boolean;
  is_active: boolean;
}

export type { WarehouseItem };

export function useWarehouses() {
  return useQuery({
    queryKey: ['warehouses'],
    queryFn: () => api.get<WarehouseItem[]>('/warehouses'),
  });
}
